import { forwardRef } from 'react';

const Receipt = forwardRef(({ booking, venue, payment, totalAmount }, ref) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0
    }).format(amount || 0);
  };

  const transactionDate = booking?.created_at ? new Date(booking.created_at) : new Date();
  const maskedPhone = (() => {
    const raw = String(booking?.customer_phone || '').replace(/\D/g, '');
    if (!raw) return '-';
    const last3 = raw.slice(-3);
    return `XXXX${last3}`;
  })();

  const timeSlots = Array.isArray(booking?.time_slots) 
    ? booking.time_slots 
    : [booking?.time_slot || '-'];
  
  const totalHours = timeSlots.length;
  const pricePerHour = venue?.price_per_hour || 0;
  const resolvedTotal = payment?.amount != null ? Number(payment.amount) : (totalAmount != null ? Number(totalAmount) : null);
  const totalPrice = Number.isFinite(resolvedTotal) ? resolvedTotal : totalHours * pricePerHour;

  return (
    <div 
      ref={ref} 
      data-receipt-root
      className="bg-white text-black p-6 w-[300px] font-mono text-sm"
      style={{ fontFamily: 'monospace' }}
    >
      <div className="text-center border-b-2 border-dashed border-gray-400 pb-4 mb-4">
        <h1 className="text-xl font-bold">ZERO FUTSAL</h1>
        <p className="text-xs text-gray-600 uppercase tracking-wide">just play and fun</p>
        <p className="text-xs text-gray-600">Jl. Terusan Rancagoong No.13, Gumuruh, Kec. Batununggal, Kota Bandung, Jawa Barat 40275</p>
        <p className="text-xs text-gray-600">Telp: 0811-2292-376</p>
      </div>

      <div className="border-b-2 border-dashed border-gray-400 pb-4 mb-4">
        <div className="flex justify-between text-xs mb-1">
          <span>No. Transaksi:</span>
          <span>{booking?.id?.substring(0, 8).toUpperCase() || '-'}</span>
        </div>
        <div className="flex justify-between text-xs mb-1">
          <span>Tanggal Transaksi:</span>
          <span>{transactionDate.toLocaleDateString('id-ID')}</span>
        </div>
        <div className="flex justify-between text-xs">
          <span>Waktu:</span>
          <span>{transactionDate.toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit' })}</span>
        </div>
      </div>

      <div className="border-b-2 border-dashed border-gray-400 pb-4 mb-4">
        <p className="text-xs font-bold mb-1">PELANGGAN:</p>
        <p className="text-xs">{booking?.customer_name || '-'}</p>
        <p className="text-xs">No telp: {maskedPhone}</p>
      </div>

      <div className="border-b-2 border-dashed border-gray-400 pb-4 mb-4">
        <p className="text-xs font-bold mb-2">DETAIL BOOKING:</p>
        
        <div className="flex justify-between text-xs mb-1">
          <span>Lapangan:</span>
          <span>{venue?.name || '-'}</span>
        </div>
        <div className="flex justify-between text-xs mb-1">
          <span>Tanggal Booking:</span>
          <span>{booking?.booking_date || '-'}</span>
        </div>
        <div className="text-xs mb-2">
          <span>Jam:</span>
          <div className="ml-2">
            {timeSlots.map((slot, idx) => (
              <div key={idx}>{slot}</div>
            ))}
          </div>
        </div>
        
        <div className="border-t border-gray-300 pt-2 mt-2">
          <div className="flex justify-between text-xs">
            {pricePerHour > 0 && resolvedTotal == null ? (
              <span>{totalHours} jam x {formatCurrency(pricePerHour)}</span>
            ) : (
              <span>Total Durasi: {totalHours} jam</span>
            )}
          </div>
        </div>
      </div>

      <div className="border-b-2 border-dashed border-gray-400 pb-4 mb-4">
        <div className="flex justify-between text-xs mb-1">
          <span>Metode Bayar:</span>
          <span className="uppercase">{payment?.method || 'CASH'}</span>
        </div>
        <div className="flex justify-between text-xs mb-1">
          <span>Status:</span>
          <span className="uppercase">{payment?.status === 'verified' ? 'LUNAS' : 'PENDING'}</span>
        </div>
      </div>

      <div className="text-center mb-4">
        <p className="text-xs mb-1">TOTAL PEMBAYARAN</p>
        <p className="text-2xl font-bold">
          <span className="inline-block mr-2">Rp</span>
          <span className="inline-block">{new Intl.NumberFormat('id-ID', { minimumFractionDigits: 0 }).format(totalPrice || 0)}</span>
        </p>
      </div>

      <div className="text-center border-t-2 border-dashed border-gray-400 pt-4">
        <p className="text-xs mb-1">Terima Kasih Telah Bermain di</p>
        <p className="text-xs font-bold">ZERO FUTSAL</p>
        <p className="text-xs text-gray-500 mt-2">Struk Ini adalah Bukti Pembayaran yang sah</p>
      </div>
    </div>
  );
});

Receipt.displayName = 'Receipt';

export default Receipt;
